import { Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

function NaoEncontrado() {
  return (
    <Container
      className="transicao d-flex flex-column align-items-center justify-content-center text-center"
      data-bs-theme="dark"
      style={{ minHeight: "60vh", gap: "1rem" }}
    >
      <div style={{ fontSize: "6rem", lineHeight: 1 }}>404</div>
      <h1 className="h3">Página não encontrada</h1>
      <p className="text-muted">A página que você está procurando não existe ou foi movida.</p>
      <NavLink to="/" className="btn btn-outline-primary">
        Voltar para o início
      </NavLink>
    </Container>
  );
}

export default NaoEncontrado;
